import React from "react";
import { Modal, Table } from "antd";

const CostomerItem = ({ visible, onClose, onRowClick, data1 }) => {
  console.log(data1);
  const columns = [
    { title: "Order Code", dataIndex: "booking_no", key: "booking_no" },
    {
      title: "Item",
      dataIndex: "item",
      key: "item",
    },
    { title: "Size", dataIndex: "size", key: "size" },
    // { title: "Contract Qty", dataIndex: "sauda_qty", key: "sauda_qty" },
    // { title: "Contract Rate", dataIndex: "sauda_rate", key: "sauda_rate" },
  ];

  return (
    <Modal
      title="Select Here"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={900}
    >
      <Table
        dataSource={data1}
        columns={columns}
        onRow={(record) => {
          return {
            onClick: () => {
              onRowClick(record);
              onClose();
            },
          };
        }}
      />
    </Modal>
  );
};

export default CostomerItem;
